export const PAY_SUCCESS_SOCKET = 5;
export const PAY_HAS_SCANNED_SOCKET = 7;
